module.exports = __webpack_public_path__ + "static/community-slideshow-02-1e89b83064f5a833aefbc5ede1f31ebb.jpg";